import React, { useState } from 'react';
import ResponsiveDrawer from '../../Admin/Components/Drawer/Drawer';
import { 
  Box, 
  Button, 
  Typography, 
  Grid, 
  Container,
  Card,
  CardMedia,
  CardContent,
  Snackbar,
  Alert
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { postAds } from '../../Services/AdminServices'; 
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';


// Fix the styled component - it should be capitalized
const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: "#fff",
  boxShadow: 'none',
  marginBottom: 20,
  width: '70%',
  '@media (max-width: 1200px)': {
    width: '70%', // Adjust width for desktop
  },
  '@media (max-width: 992px)': {
    width: '100%', // Adjust width for tablets
  },
  '@media (max-width: 768px)': {
    width: '100%', // Adjust width for Mobiles
  },
}));

const NewAds = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      // Create preview URL for the selected image
      const fileReader = new FileReader();
      fileReader.onload = () => {
        setPreviewUrl(fileReader.result);
      };
      fileReader.readAsDataURL(file);
    }
  };
  
  const handleSave = async () => {
    if (!selectedFile) {
      setNotification({
        open: true,
        message: 'Please select an image first',
        severity: 'error'
      });
      return;
    }
  
    try {
      setLoading(true);
  
      const formData = new FormData();
      formData.append('image', selectedFile);
  
      const response = await postAds(formData);
  
      setNotification({
        open: true,
        message: 'Ad image uploaded successfully!',
        severity: 'success'
      });
  
      // Reset form
      setSelectedFile(null);
      setPreviewUrl(null);
  
      // 🔁 Navigate to adminad page after a slight delay
      setTimeout(() => {
        navigate('/admin/adminad');
      }, 1000);
  
    } catch (error) {
      console.error('Error uploading ad:', error);
      setNotification({
        open: true,
        message: error.response?.data?.message || 'Failed to upload ad image',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };
  

  const handleCloseNotification = () => {
    setNotification(prev => ({ ...prev, open: false }));
  };

  return (
    <Container maxWidth="lg" sx={{ padding: 0 }}>
      <Grid container spacing={2}>
        {/* Sidebar (Responsive Drawer) */}
        <Grid item xs={12} lg={2}>
          <ResponsiveDrawer />
        </Grid>
        <Grid item xs={12} lg={10} sx={{ mt: 12 }}>
          <Box sx={{ mb: 2, px: { xs: 2, sm: 3 } }}> {/* Added responsive horizontal padding */}
            <Grid container alignItems="center">
              <Grid item xs>
              <Typography
  variant="h5"
  gutterBottom
  sx={{
    fontWeight: 'bold',
    ml: { xs: 2, sm: 0 } // 👈 Add margin-left only for mobile
  }}
>
  Add New Ads
</Typography>

              </Grid>
            </Grid>
          </Box>
          
          {/* Material UI Upload Photo Card */}
          <Box sx={{ px: { xs: 2, sm: 2 } }}> {/* Added responsive horizontal padding */}
            <StyledCard> {/* Using the properly named styled component */}
              <CardContent>
                <input
                  type="file"
                  id="photo-upload"
                  accept="image/*"
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                />
                <label htmlFor="photo-upload">
                  <Button
                    variant="outlined"
                    component="span"
                    startIcon={<CloudUploadIcon />}
                    sx={{ 
                      mb: 2, 
                      width: { xs: '100%', sm: '70%' }, // Responsive width
                      color: '#4285F4',
                      borderColor: '#ccc'
                    }}
                  >
                    UPLOAD PHOTO
                  </Button>
                </label>
                
                {previewUrl && (
                  <CardMedia
                    component="img"
                    height="200"
                    image={previewUrl}
                    alt="Photo preview"
                    sx={{ borderRadius: 1, mt: 2 }}
                  />
                )}
                
                {selectedFile && (
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1, textAlign: 'center' }}>
                    {selectedFile.name}
                  </Typography>
                )}
              </CardContent>
            </StyledCard>
         
            {/* Save Button */}
            <Box sx={{ mb: 3 }}>
            <Button   
  onClick={handleSave}   
  variant="contained"   
  // disabled={loading || !selectedFile}   
  sx={{     
    backgroundColor: '#A56266',     
    color: '#FFFFFF',  // Changed from '#A56266' to white
    fontWeight: 'bold',     
    ml: { xs: 2, sm: 0 },     
    '&:hover': {       
      backgroundColor: '#8e5357'     
    }   
  }} 
>   
  {loading ? 'SAVING...' : 'SAVE ADS'} 
</Button>

            </Box>
          </Box>
          
          {/* Notification Snackbar */}
          <Snackbar 
            open={notification.open} 
            autoHideDuration={6000} 
            onClose={handleCloseNotification}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          >
            <Alert 
              onClose={handleCloseNotification} 
              severity={notification.severity} 
              sx={{ width: '100%' }}
            >
              {notification.message}
            </Alert>
          </Snackbar>
        </Grid>
      </Grid>
    </Container>
  );
};

export default NewAds;